import React, {useEffect, useState} from 'react';
import {wdiCore} from '@/components/WdiControls';
import {ColumnsType} from 'antd/lib/table';
import PanelForWarningApp, {
  WarningInfoAppProps,
  WarningInfoApprovalProps,
  WdiGridApp,
  WdiObjApp,
} from '@/components/WdiBus/PanelForWarning';
import {Empty, message} from 'antd';
import {getFormUrlMapping} from '@/components/WdiBus/FormPage';
import {Enum} from '@/enums/system';
import {FormApi} from '@/services/sales';
import {ResponseStatus} from '@/utils/request';
import {FormSaMkt} from '@/services/mkt/sa';

const showDispModal = (evt: any) => {
  if (evt && evt.target) {
    const dataKey = evt.target.getAttribute("data-key");
    const record = JSON.parse(evt.target.getAttribute("data-record"));
    FormApi.doesAccess(dataKey).then(response => {
      if (response.code == ResponseStatus.SUCCESS && response.data) {
        window.open(getFormUrlMapping(record.pageTypeId, record.formTypeId) + `?formId=${dataKey}&pageTypeId=${record.pageTypeId}&formTypeId=${record.formTypeId}`);
      } else {
        message.error("没有权限查看单据");
      }
    })
  }
};

const activityStatus = [
  {text: '待审批', value: String(Enum.FormStatus.AWAITING)}
  , {text: '已审批', value: String(Enum.FormStatus.APPROVE_COMPLETED)}
  , {text: '退回待修改', value: String(Enum.FormStatus.REJECTED)}
  , {text: '作废', value: String(Enum.FormStatus.SCRAP)}
  , {text: '已审批未结案', value: '5'}
  , {text: '已审批结案中', value: '6'}
  , {text: '已审批已结案', value: '7'}
  , {text: '已审批未关闭', value: '8'}
  , {text: '已审批已关闭', value: '9'}
];

const HQBudgetAmount: Record<string, any> = {
  bohqId: (_: any, record: any) => {
    return record['bohqName'];
  },
  ecMktId: (_: any, record: any) => {
    return record['ecMktName'];
  },
  productCode: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['productCode'], record['productName']);
  },
  amountTotal: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountTotal'], 2);
  },
  amountApproving: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApproving'], 2);
  },
  amountUsaged: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountUsaged'], 2);
  },
  amountApUsCount: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountApUsCount'], 2);
  },
  amountRemain: (_: any, record: any) => {
    return wdiCore.Number.AmountToString(record['amountRemain'], 2);
  },
  amount: (_: any, record: any) => {
    if (record['amount'] > record['amountRemain']) {
      return <span style={{color: '#ff0000'}}>{wdiCore.Number.AmountToString(record['amount'], 2)}</span>;
    }
    return wdiCore.Number.AmountToString(record['amount'], 2);
  },
  rowNumbers: (_: any, record: any) => {
    if (record['amount'] > record['amountRemain']) {
      return <span style={{color: '#ff0000'}}>{record['rowNumbers']}</span>;
    }
    return record['rowNumbers'];
  },
};
const DuplicatedGeneralActivity: Record<string, any> = {
  formNo: (_: any, record: any) => {
    return <a onClick={showDispModal} data-key={record.formId} data-record={JSON.stringify(record)}>
      {record.formNo}
    </a>;
  },
  formStatus: (_: any, record: any) => {
    var html = "";
    if (record.statusId === 2) {
      if (record.isClosed) {
        html = "已审批已关闭";// formContext.Res.Closed;
      } else {
        html = "已审批未关闭";//formContext.Res.NotClosed;
        if (record.settlementMode === 1 || record.settlementMode === 2) {
          if (record.settledStatus === 2) {
            html = "已审批已结案";// formContext.Res.Settled;
          } else if (record.settledStatus === 1) {
            html = "已审批结案中";// formContext.Res.Settling;
          } else {
            html = "已审批未结案"; //formContext.Res.NotSettleted;
          }
        }
      }
    } else {
      activityStatus.forEach((item: any) => {
        if (wdiCore.String.EqIngoreCase(String(record.statusId), item.value)) {
          html = item.text;
          return false;
        }
        return true;
      })
    }
    return html;
  },
  soldTo: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['soldToCode'], record['soldToName']);
  },
  shop: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['shopCode'], record['shopName']);
  },
  ec: (_: any, record: any) => {
    return record['ecName'];
  },
  product: (_: any, record: any) => {
    return record['productBuyNames'];
  },
  originalActivityDate: (_: any, record: any) => {
    return wdiCore.Date.Join(record['originalActivityStartDate'], record['originalActivityEndDate']);
  },
  currentActivityDate: (_: any, record: any) => {
    return wdiCore.Date.Join(record['currentActivityStartDate'], record['currentActivityEndDate']);
  },
  originalRowNumber: (_: any, record: any) => {
    return <span style={{color: '#ff0000'}}>{record['originalRowNumber']}</span>;
  },
  currentRowNumber: (_: any, record: any) => {
    return <span style={{color: '#ff0000'}}>{record['currentRowNumber']}</span>;
  },
};
const DuplicatedPdActivity: Record<string, any> = {
  formNo: (_: any, record: any) => {
    return <a onClick={showDispModal} data-key={record.formId} data-record={JSON.stringify(record)}>
      {record.formNo}
    </a>;
  },
  formStatus: (_: any, record: any) => {
    var html = "";
    if (record.statusId === 2) {
      if (record.isClosed) {
        html = "已审批已关闭";// formContext.Res.Closed;
      } else {
        html = "已审批未关闭";//formContext.Res.NotClosed;
        if (record.settlementMode === 1 || record.settlementMode === 2) {
          if (record.settledStatus === 2) {
            html = "已审批已结案";// formContext.Res.Settled;
          } else if (record.settledStatus === 1) {
            html = "已审批结案中";// formContext.Res.Settling;
          } else {
            html = "已审批未结案"; //formContext.Res.NotSettleted;
          }
        }
      }
    } else {
      activityStatus.forEach((item: any) => {
        if (wdiCore.String.EqIngoreCase(String(record.statusId), item.value)) {
          html = item.text;
          return false;
        }
        return true;
      })
    }
    return html;
  },
  soldTo: (_: any, record: any) => {
    return wdiCore.String.CodeOrName(record['soldToCode'], record['soldToName']);
  },
  product: (_: any, record: any) => {
    return record['productBuyNames'];
  },
  revenueType: (_: any, record: any) => {
    return record['revenueTypeName'];
  },
  originalSupplyDate: (_: any, record: any) => {
    return wdiCore.Date.Join(record['originalSupplyStartDate'], record['originalSupplyEndDate']);
  },
  currentSupplyDate: (_: any, record: any) => {
    return wdiCore.Date.Join(record['currentSupplyStartDate'], record['currentSupplyEndDate']);
  },
  originalRowNumber: (_: any, record: any) => {
    return <span style={{color: '#ff0000'}}>{record['originalRowNumber']}</span>;
  },
  currentRowNumber: (_: any, record: any) => {
    return <span style={{color: '#ff0000'}}>{record['currentRowNumber']}</span>;
  },
};
const columnsRenders: Record<string, Record<string, any>> = {
  SaMktBudget: HQBudgetAmount,
  DuplicatedGeneralActivity: DuplicatedGeneralActivity,
  DuplicatedPdActivity: DuplicatedPdActivity,
};

const renderWdiGridApp = (props: API.WdiGrid, index: number) => {
  const columns: ColumnsType<any> = [];
  const columnsRender = columnsRenders[props.key];
  props.wdiColumns.map((wdiColumn) => {
    if (!wdiColumn.isHidden) {
      const column: any = {
        title: wdiColumn.displayName,
        dataIndex: wdiColumn.name,
        width: wdiColumn.width,
        ellipsis: true,
      };
      if (columnsRender && columnsRender[wdiColumn.name]) {
        column.render = columnsRender[wdiColumn.name];
      }
      columns.push(column);
    }
  });
  return ((props.status != 0 || props.showAlways) &&
    <WdiGridApp key={props.key} wdiGrid={props} columns={columns} dataSource={props.items}/>);
};

const renderWdiObjApp = (props: API.WdiObj, index: number) => {
  return ((props.status != 0 || props.showAlways) && <WdiObjApp key={index} wdiObj={props} message={props.target}/>);
};

const SaMktWarningInfoApp: React.FC<WarningInfoAppProps> = (props) => {
  let status: 0 | 1 | 2 = 0;
  props.wdiPanelList?.items.map((item) => {
    if (item.status === 2) {
      status = 2;
    }
    if (status !== 2 && item.status === 1) {
      status = 1;
    }
  });
  return (
    <PanelForWarningApp
      title={props.title}
      visible={props.visible}
      status={status}
      onClose={props.onClose}
      onSave={props.onSave}
    >
      {props.wdiPanelList?.items.map((item, index) => {
        if (item.type === 'WdiGrid') {
          return renderWdiGridApp(item, index);
        } else if (item.type === 'WdiObj') {
          return renderWdiObjApp(item, index);
        } else {
          return <></>;
        }
      })}
    </PanelForWarningApp>
  );
}
export default SaMktWarningInfoApp;

export const SaMktWarningApprovalApp: React.FC<WarningInfoApprovalProps> = (props) => {
  const [isWarning, setIsWarning] = useState(false);
  const [paneList, setPaneList] = useState<API.WdiPanelList>();
  useEffect(() => {
    if (props?.formId) {
      FormSaMkt.warningInfos(props?.formId).then(response => {
        if (response?.data && response?.data.items && response?.data.items.length > 0) {
          setIsWarning(true);
        }
        setPaneList(response?.data);
      });
    }
  }, [props.formId]);

  return (
    <>
      {isWarning && paneList != undefined && paneList.items.map((item, index) => {
        if (item.type === 'WdiGrid') {
          return renderWdiGridApp(item, index);
        } else if (item.type === 'WdiObj') {
          return renderWdiObjApp(item, index);
        } else {
          return <></>;
        }
      })}
      {!isWarning &&
        <div>
          <div style={{marginTop: "200px", textAlign: "center"}}>
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="没有任何警示信息"/>
          </div>
        </div>
      }
    </>
  );
};
